// Login.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom'; // Updated import
import './Login.css';
import './ResponsiveLogin.css';
import './CreatePrescription.css';
import { login, isAuthenticated } from './helper/auth'; // Import the login function from auth.js
import axios from 'axios'; // Import axios for API calls
import Logo from '../assets/img/Logo.png';
import { Link, useLocation } from 'react-router-dom';
import BG from '../assets/img/bg.png';

function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [currentUser, setCurrentUser] = useState();
  const [error, setError] = useState('');
  const navigate = useNavigate(); // Updated: useNavigate replaces useHistory
  const [rememberMe, setRememberMe] = useState(false);

  // Redirect to dashboard if already logged in
  useEffect(() => {
    if (isAuthenticated()) {
      navigate('/dashboard');
    }
  }, [navigate]);


  const handleLogin = async (e) => {
    e.preventDefault();
    try {
    const response = await fetch(`${process.env.REACT_APP_AXIOS_BASE_URL}/api/sneho-login/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          username: username,
          password: password,
        }),
      });
      if (!response.ok) {
         throw new Error('Login failed'); // Handle non-200 status codes
       }

       const data = await response.json();

       if (data.token) {
         // const token = data.token;
        // Store token (You can store it in localStorage or cookies)
            // console.log(resp.data);
             if (data.doctor || data.is_superuser) {
                let forLocalstorage = {
                  doctor: data.doctor || null,
                  doctor_id: data.doctor_id || null,
                  email: data.email || '',
                  token: data.token,
                  user_id: data.user_id || '',
                  name: data.name || '',
                  username: data.username || '',
                };
                // setCurrentUser(forLocalstorage);
                const storage = rememberMe ? localStorage : sessionStorage;
                localStorage.setItem('user-info', JSON.stringify(forLocalstorage));
                localStorage.setItem('authToken', data.token);
                localStorage.setItem('isLoggedIn', true);
                // Set user as authenticated
                // when doctor 2 lines
                login();
                // Redirect to dashboard
                navigate('/dashboard');
            }
            else {
               setError('User is not authorized to access this application')
            }


      } else {
        setError('Invalid login response');
      }
    } catch (error) {
      console.error('Login error:', error);
      setError('Invalid username or password');
    }
  };

  return (
    <div className="login-container create-prescription">
      <div className="login-left">
        <img
          src={BG}
          alt="Login"
          className="login-image"
        />
      </div>
      <div className="login-right">
        <div className="login-form">
          <img src={Logo} alt="Sneho Health Logo " className="logo-image login-page" />
          <form onSubmit={handleLogin} className="login-form">
          <span className="form-title">Please Log in to continue transforming patient care</span>
            <div className="form-group">
              <input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className="form-control"
                placeholder="Enter username or email"
                required
              />
              <label>Username:</label>
            </div>
            <div className="form-group">
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="form-control"
                placeholder="Enter password"
                required
              />
              <label>Password:</label>
            </div>
            <div className="form-links">
              <span className="remember-me">
                <input
                type="checkbox"
                name="remember"
                checked={rememberMe}
                onChange={() => setRememberMe(!rememberMe)}
                 />
                <span className="remember-label">Remember me</span>
              </span>
              <Link to="forget-password/" className="forgot-password-link">Forgot Password?</Link>
            </div>
            {error && <div className="error">{error}</div>}
            <button type="submit" className="btn btn-primary">Login</button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Login;
